import type { Doc, Id } from "./api";
import type { FlatSection } from "../domain/legislation";
import { docToPlainText, richTextDocOrEmpty } from "../domain/richText";
import type { DefinedTerm, DefinedTermMap } from "../domain/definedTerms";

/** Map a Convex sections doc to the pure-domain FlatSection shape. */
export const toFlatSection = (s: Doc<"sections">): FlatSection<Id<"sections">> => ({
  id: s._id,
  parentId: s.parentId,
  nodeType: s.nodeType,
  number: s.number,
  title: s.title,
  order: s.order,
  hidden: s.hidden,
});

/** Build the term → plain-text-definition map used for hover highlighting. */
export const toDefinedTermMap = (
  terms: readonly Doc<"definedTerms">[],
): DefinedTermMap => {
  const map = new Map<string, DefinedTerm>();
  for (const t of terms) {
    map.set(t.term, {
      text: docToPlainText(richTextDocOrEmpty(t.definition)).trim(),
      caseSensitive: t.caseSensitive,
    });
  }
  return map;
};
